"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),t=require("react"),o=require("styled-components"),a=require("@vds-tokens/core"),n=require("@vds-core/utilities"),i=require("@plans/utilities");function r(e){return e&&e.__esModule?e:{default:e}}var l=r(o);const s=l.default.div.withConfig({displayName:"Container",componentId:"VDS__sc-1y1mr6b-0"})`
  align-items: center;
  display: flex;
  flex-direction: row;
  pointer-events: auto;
`,d=l.default.div.withConfig({displayName:"ToggleWrapper",componentId:"VDS__sc-1y1mr6b-1"})`
  border-radius: 28px;
  display: inline-block;
  height: 30px;
  outline: 0;
  position: relative;
`,c=l.default.span.withConfig({displayName:"HitArea",componentId:"VDS__sc-1y1mr6b-2"})`
  ${({disabled:e})=>!e&&"cursor: pointer;"}
  display: inline-block;
  height: ${n.calculateRem(44)};
  left: 50%;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 1;
`,u=l.default.label.withConfig({displayName:"StyledLabel",componentId:"VDS__sc-1y1mr6b-3"})`
  border-radius: 28px;
  display: inline-flex;
  height: 30px;
  width: 52px;
  ${({disabled:e,keyboardFocused:t,surface:o})=>!e&&t&&`\n    &:not(:hover) {\n      outline: none;\n      &::before {\n        border: ${n.calculateRem(a.AccessibilityTokens.focusring.borderwidth.value)} ${a.AccessibilityTokens.focusring.borderstyle.value} ${"dark"===o?a.AccessibilityTokens.color.focusring.ondark.value:a.AccessibilityTokens.color.focusring.onlight.value};\n        border-radius: 24px;\n        content: '';\n        height: calc(100% + 4px);\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: calc(100% + 4px);\n      }\n    }\n    `}
`,p=l.default.span.withConfig({displayName:"ToggleSwitchSlider",componentId:"VDS__sc-1y1mr6b-4"})`
  /* background-color: #33333350; */
  background-color: ${({backgroundColor:e})=>e};
  border: 1px solid
    ${({surface:e})=>"light"===e?"rgba(0, 0, 0, 0.6)":a.ColorTokens.elements.primary.ondark.value};
  border-radius: 1rem;
  color: ${({disabled:e,surface:t})=>a.ColorTokens.elements[e?"secondary":"primary"][`on${t}`].value};
  cursor: ${({disabled:e})=>e?null:"pointer"};
  display: inline-flex;
  height: 28px;
  position: relative;
  transition: background-color 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  width: 52px;
  &::before {
    background-color: ${({buttonColor:e})=>e};
    border-radius: 50%;
    bottom: 0;
    content: '';
    height: ${a.LayoutTokens.space["6X"].value};
    left: 2px;
    margin-bottom: auto;
    margin-top: auto;
    padding-left: 0;
    position: absolute;
    top: 0;
    transition: left 100ms;
    width: ${a.LayoutTokens.space["6X"].value};
    filter: drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.24))
      drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.08));
  }

  &:active,
  &:focus {
    outline: none;
  }

  ${({toggleOn:e})=>e&&`\n    &::before {\n      content: '';\n      left: ${a.LayoutTokens.space["6X"].value} !important; \n      transition: left 100ms; \n    }\n  `};
`,b=l.default.input.withConfig({displayName:"ToggleInput",componentId:"VDS__sc-1y1mr6b-5"})`
  height: 1rem;
  margin: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 2rem;
  &:hover {
    ${({disabled:e})=>!e&&"cursor: pointer;"}
  }
`;var g=n.withVDSManager((({on:o=!1,disabled:n,onChange:r,name:l,value:g,inputId:m,index:f,onKeyDown:h,tabIndex:k,"data-track":y,"data-clickstream":x,"data-analyticstrack":v,"data-track-ignore":C,surface:w="light",id:$,ariaLabel:T,controlled:_})=>{const[D,I]=t.useState(o),[S,j]=t.useState(!1),V=m||i.generateId();t.useEffect((()=>I(o)),[o]);const q=e=>{e.stopPropagation(),n||(r&&r(e,{name:l,value:g,on:!D,index:f}),_||I(!D))};return e.jsx(s,{children:e.jsxs(d,Object.assign({onClick:e=>(e=>{e.stoppropagation(),38!==e.keyCode&&40!==e.keyCode||e.preventDefault()})(e),id:$,onKeyDown:e=>{const t=" "===e.key,o="Enter"===e.key;t&&e.preventDefault(),(o||t)&&"click"!==e.type&&(q(e),h&&h(e))}},{children:[e.jsx(c,{"aria-hidden":"true",disabled:n,"data-testid":"test-hitArea",onClick:n?null:e=>q(e)}),e.jsxs(u,Object.assign({id:`label-${V}`,disabled:n,surface:w,htmlFor:m||l||"toggle",keyboardFocused:S},{children:[e.jsx(b,{"data-testid":"test-toggle","aria-label":T||l,type:"checkbox",disabled:n,checked:D,name:l,value:g,id:V,tabIndex:k,"data-analyticstrack":v,"data-track":y,"data-track-ignore":C,"data-clickstream":x,onFocus:()=>j(!0),onBlur:()=>j(!1),onChange:r,onKeyDown:h,onClick:q}),e.jsx(p,{tabIndex:-1,"aria-hidden":!0,surface:w,disabled:n,toggleOn:D,backgroundColor:n?a.ColorTokens.interactive.disabled[`on${w}`].value:D?a.ColorTokens.palette.green36.value:"rgba(51, 51, 51, 0.50)",buttonColor:n&&"light"===w?"rgba(51, 51, 51, 0.5)":n&&"dark"===w?a.ColorTokens.palette.gray44.value:a.ColorTokens.elements.primary.ondark.value})]}))]}))})}));exports.default=g;
